import React from 'react'
import { DNABox, DNAText } from '@alucio/lux-ui'
import { FolderORM } from 'src/types/orms'
import { BaseInfoPanelProps } from '../InfoPanel'
import { useInfoPanelState } from '../State/InfoPanelStateProvider'
import { ActionBarElement } from '../ActionBar/ActionBar'
import ContentPanels from '../ContentPanels/ContentPanels'
import { isFolderORM } from 'src/types/typeguards'
import useFeatureFlags from 'src/hooks/useFeatureFlags/useFeatureFlags'
import { FolderStatus } from '@alucio/aws-beacon-amplify/src/models'

export interface FolderVariantProps extends BaseInfoPanelProps {
  variant: 'Folder'
  folderORM?: FolderORM
}

const FolderVariant: React.FC<FolderVariantProps> = props => {
  const { folderORM } = props
  const { collapsed, activeActionBarOption, setCollapsed, handlePressActionBarOption } = useInfoPanelState()
  const enableSharedFolders = useFeatureFlags('enableSharedFolders')

  if (!isFolderORM(folderORM) || folderORM.model.status !== FolderStatus.ACTIVE) return (<></>)

  const actionBarOptions: ActionBarElement[] = [
    {
      icon: collapsed ? 'caret-left' : 'caret-right',
      onPress: () => setCollapsed(!collapsed),
      popoverContent: collapsed
        ? <DNAText colorMode="dark">Expand</DNAText>
        : <DNAText colorMode="dark">Collapse</DNAText>,
      style: { borderBottomWidth: 1, borderBottomColor: '#EBEBEB' },
      key: 'toggle-collapsed',
    },
    {
      icon: 'users',
      onPress: () => handlePressActionBarOption('Sharing'),
      active: activeActionBarOption === 'Sharing',
      popoverContent: <DNAText colorMode="dark">Sharing</DNAText>,
      key: 'sharing',
    },
    {
      icon: 'info',
      onPress: () => handlePressActionBarOption('Details'),
      active: activeActionBarOption === 'Details',
      popoverContent: <DNAText colorMode="dark">Details</DNAText>,
      key: 'details',
    },
  ]

  // IF THE USER DOESN'T OWN THE FOLDER,
  // THE SHARING OPTION SHOULD BE HIDDEN
  if (folderORM?.meta.isSharedWithTheUser || !enableSharedFolders) {
    actionBarOptions.splice(1, 1);
  }

  return (
    <DNABox appearance="row" fill>
      <ContentPanels itemORM={folderORM}/>
    </DNABox>
  )
}

export default FolderVariant
